import { useMemo } from "react";
/**
 * Hook pour grouper les conteneurs par super-conteneur et par temps
 */
export const useSuperContainerGrouping = (
  dataContainerCollection,
  superContainers,
) => {
  const superPairsByTime = useMemo(() => {
    if (!Array.isArray(superContainers) || superContainers.length === 0)
      return new Map();

    const idSet = new Set(
      superContainers.flatMap((sc) => sc?.containerObjectIdList || []),
    );

    const groups = new Map();
    for (const rec of dataContainerCollection) {
      if (!idSet.has(rec._id)) continue;
      const arr = groups.get(rec._time) || [];
      arr.push(rec);
      groups.set(rec._time, arr);
    }

    for (const arr of groups.values()) {
      arr.sort((a, b) => {
        const aIsLeft = a._value_image?.includes("-L.jpeg") ? -1 : 1;
        const bIsLeft = b._value_image?.includes("-L.jpeg") ? -1 : 1;
        return aIsLeft - bIsLeft;
      });
    }
    return groups;
  }, [dataContainerCollection, superContainers]);

  return { superPairsByTime };
};
